import { gql } from "@apollo/client";
export default gql`
  mutation GenerateMfaToken($input: GenerateTokenInput!) {
    generateMfaToken(input: $input) {
      tokenGenerated
      message
    }
  }
`;
